<template>
    <div class="page">
        <query-form :form="form" ref="queryForm" @dateChange="dateChange" />
        <search-bar :ordersPrice="ordersPrice" :count="count" />
        <el-table :data="payBillList" style="width: 100%" header-row-class-name="table-header">
            <el-table-column v-for="item of tableHead" :key="item.prop" :label="item.label" :width="item.width || 'auto'">
                <template slot-scope="{row}">
                    <template v-if="item.prop">
                        <span v-if="item.prop==='status'">
                            <span>{{ row.status | getTypeStatus }}</span>
                        </span>
                        <span v-else-if="item.prop==='tradeChannel'">
                            <span>{{ row.tradeChannel | getTradeChannel }}</span>
                        </span>
                        <span v-else>{{ row[item.prop] }}</span>
                    </template>
                    <template v-else>
                        <div class="btn-container">
                            <span class="btn" v-if="row.status===1||row.status===2||row.status===3||row.status===4" @click="tradInfo(row)">查看</span>
                            <span class="btn" v-if="row.status===3" @click="refund(row)">退款</span>
                            <span class="btn" v-if="row.status===5||row.status===6||row.status===8" @click="viewRefund(row)">查看退款单</span>
                        </div>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <Pagination :params="form" @changeSize="changeSize" @changePage="changePage" />
        </div>
        <refundDialog ref="openDialog"></refundDialog>
    </div>
</template>

<script>
import { tradState, channelList, typeList } from '@trading/static/data.js';
import { mapActions, mapState } from 'vuex';
import queryForm from '@trading/components/query-form.vue';
import searchBar from '@trading/components/search-bar.vue';
import refundDialog from '@trading/components/refund-dialog.vue';
export default {
  name: 'indexList',
  computed: {
    ...mapState({
      payBillList: (state) => state.trading.payBillList,
      ordersPrice: (state) => state.trading.ordersPrice,
      count: (state) => state.trading.count,
      total: (state) => state.trading.total,
    }),
  },
  provide() {
    return {
      submit: this.queryTableInfo,
      formList: tradState.query_form_list,
      tradTime: tradState.tradTime,
      searchList: this.getSearchList,
      searchPlaceholder: tradState.searchPlaceholder,
      downLoadExcel: this.downLoadExcel,
      rightList: tradState.rightList,
      resetForm: this.resetForm,
    };
  },
  components: {
    queryForm,
    searchBar,
    refundDialog,
  },
  filters: {
    getTradeChannel(code) {
      return channelList.get(code);
    },
    getTypeStatus(code) {
      return typeList.get(code);
    },
  },
  data() {
    return {
      form: {
        timeType: null, // 1:支付时间2:交易时间 3:提交时间4:完成时间
        startTime: '', //开始时间
        endTime: '', //结束时间
        payChannel: '', //支付渠道 微信/支付宝/汇付宝/银联
        payType: '', //支付类型:JSAPI JSGZHAPI MICROPAY F2FPAY APP等等
        mchCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode, //商户Code
        payStatus: 0, //0未知（支付全部状态），1待支付，2支付中，3已支付，4支付失败，5退款中，6已退款，7退款失败,8已支付(含退款)
        outTradeNo: '', //订单号
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableHead: tradState.tableHead,
    };
  },
  async created() {
    await this.queryPayBill(this.form);
    this.form.total = this.total;
  },
  methods: {
    ...mapActions('trading', ['queryPayBill']),
    // 条件查询
    async queryTableInfo(form) {
      Object.assign(this.form, form);
      await this.queryPayBill(this.form);
      this.form.total = this.total;
    },
    // 搜索
    async getSearchList(item) {
      this.form.outTradeNo = item;
      await this.queryPayBill(this.form);
      this.form.total = this.total;
    },
    // 修改条数
    changeSize(val) {
      this.form.pageSize = val;
      this.queryPayBill(this.form);
    },
    // 修改页数
    changePage(val) {
      this.form.pageNum = val;
      this.queryPayBill(this.form);
    },
    // 导出excel
    downLoadExcel() {},
    // 退款
    async refund(row) {
      this.$router.push({
        path: 'applyRefund',
        query: { id: row.id },
      });
    },
    // 查看退款单
    viewRefund(row) {
      this.$router.push({
        path: 'refund/detail',
        query: { id: row.id },
      });
    },
    //重置
    async resetForm() {
      this.form = {
        timeType: null, // 1:支付时间2:交易时间 3:提交时间4:完成时间
        startTime: '', //开始时间
        endTime: '', //结束时间
        payChannel: '', //支付渠道 微信/支付宝/汇付宝/银联
        payType: '', //支付类型:JSAPI JSGZHAPI MICROPAY F2FPAY APP等等
        mchCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode, //商户Code
        payStatus: 0, //0未知（支付全部状态），1待支付，2支付中，3已支付，4支付失败，5退款中，6已退款，7退款失败,8已支付(含退款)
        outTradeNo: '', //订单号
        pageNum: 1,
        pageSize: 10,
        total: 0,
      };
      this.$refs.queryForm.clearDate();
      await this.queryPayBill(this.form);
      this.form.total = this.total;
    },
    //日期改变
    dateChange(e) {
      this.form.startTime = e[0];
      this.form.endTime = e[1];
    },
    //查看
    tradInfo(row) {
      this.$router.push({
        path: 'list/detail',
        query: { id: row.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  .box_column();
  flex: 1;
}
.pagination {
  height: 50px;
  background-color: @bg-white;
  padding-right: 36px;
  .flex_layout(row, flex-end);
}
.btn-container {
  .flex_layout(column, center, flex-start);
  color: @primary-blue;
  .btn {
    cursor: pointer;
  }
}
// 重写element-ui样式
/deep/.table-header .cell {
  color: #999999;
  font-weight: 400;
}
/deep/.el-table__row {
  color: @font-color-black;
}
/deep/.error {
  color: #ff5f5f;
}
</style>
